/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    API_KEYS_title: "API keys",
    API_KEYS_label: "key",
    API_KEYS_pluralLabel: "keys",
    API_KEYS_description:
        "A key opens the whole Prospeneo API on behalf of a user, with their rights: their AI " +
        "assistant (MCP) or program acts as them. Customers see their keys under Settings → MCP " +
        "and API keys and can show them again; they can neither create nor revoke one.",
    API_KEYS_generate: "Generate a key",
    API_KEYS_generateTitle: "Generate an API key",
    API_KEYS_confirmGenerate: "Generate",
    API_KEYS_close: "Close",
    API_KEYS_columnUser: "User",
    API_KEYS_columnName: "Label",
    API_KEYS_columnPrefix: "Key start",
    API_KEYS_columnStatus: "Status",
    API_KEYS_columnCreated: "Created",
    API_KEYS_columnLastUsed: "Last used",
    API_KEYS_columnExpires: "Expires",
    API_KEYS_status_active: "Active",
    API_KEYS_status_expired: "Expired",
    API_KEYS_status_revoked: "Revoked",
    API_KEYS_neverUsed: "Never",
    API_KEYS_noLimit: "No limit",
    API_KEYS_actionReveal: "Show key",
    API_KEYS_actionRevoke: "Revoke",
    API_KEYS_revokeConfirm:
        "Revoke the key \"{name}\" of {email}? Anything using it loses access immediately. " +
        "This cannot be undone.",
    API_KEYS_revoked: "The key has been revoked.",
    API_KEYS_revealFailed:
        "This key cannot be shown: it is revoked, expired, or was created before 06/10/2026. " +
        "Generate a new one.",
    API_KEYS_emptyTitle: "No API keys",
    API_KEYS_loadFailedTitle: "List unavailable",
    API_KEYS_loadFailed: "The key list could not be loaded. Please try again later.",
    API_KEYS_emptyDescription: "Generate a customer's first key with \"Generate a key\".",
    API_KEYS_fieldUser: "User",
    API_KEYS_fieldUserPlaceholder: "User name or email",
    API_KEYS_changeUser: "Change",
    API_KEYS_noUserFound: "No user found.",
    API_KEYS_fieldName: "Label",
    API_KEYS_fieldNamePlaceholder: "E.g. MCP Claude Desktop",
    API_KEYS_fieldExpires: "Expiry date (optional)",
    API_KEYS_clearDate: "Clear date",
    API_KEYS_fieldExpiresHint:
        "Valid until the end of that day, Paris time. Without a date, the key never expires.",
    API_KEYS_generatedFor:
        "Key generated for {email}. It can be shown again later with \"Show key\".",
    API_KEYS_copy: "Copy",
    API_KEYS_copied: "Copied",
    API_KEYS_headersHelp: "To pass on to the customer, either header:"
};
